import { IRefIds } from 'constants/refs';
import { get } from 'services/request';

type IOptions = {
  render: () => void;
  courseId: number;
  ref: IRefIds;
  name: string;
  batch: number;
};

// Publish mechanics of one resource. Verification lives in the Publish gate (Health):
// this model only drives the export calls, slicing the publish-ids universe for
// batched resources.
export default class PublishRefModel {
  render: () => void;
  courseId: number;
  ref: IRefIds;
  name: string;
  batch: number;
  publishing = false;
  completed = false;
  failed = false;
  items: number[] = [];
  done: number[] = [];

  constructor(options: IOptions) {
    this.render = options.render;
    this.courseId = options.courseId;
    this.ref = options.ref;
    this.name = options.name;
    this.batch = options.batch;
  }

  async publish() {
    this.publishing = true;
    this.completed = false;
    this.failed = false;
    this.items = [];
    this.done = [];
    this.render();

    try {
      if (this.batch === 0) {
        await get(`courses/${this.courseId}/refs/${this.ref}/publish?ids=`);
      } else {
        this.items = await get<number[]>(`courses/${this.courseId}/refs/${this.ref}/publish-ids`);
        if (!Array.isArray(this.items)) {
          throw new Error('publish-ids failed');
        }
        this.render();
        while (this.done.length < this.items.length) {
          const batchIds = this.items.slice(this.done.length, this.done.length + this.batch);
          await get(`courses/${this.courseId}/refs/${this.ref}/publish?ids=${batchIds.join(',')}`);
          this.done = [...this.done, ...batchIds];
          this.render();
        }
      }
      this.completed = true;
    } catch (error) {
      this.failed = true;
    }
    this.publishing = false;
    this.render();
  }
}
